import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import { TriangleAlert } from 'lucide-react';
export default function MissingEquipmentWarning() {
    const { t } = useTranslation();
    return (React.createElement(TooltipProvider, null,
        React.createElement(Tooltip, null,
            React.createElement(TooltipTrigger, { asChild: true },
                React.createElement("button", { type: "button", className: "inline-flex items-center text-red-700", "aria-label": "Missing equipment warning" },
                    React.createElement(TriangleAlert, { className: "h-4 w-4" }))),
            React.createElement(TooltipContent, null, t('NOT_APPLIED_TO_AN_EQUIPMENT')))));
}
